
import barba from '@barba/core';
import GSAP from 'gsap'


import LocomotiveScroll from 'locomotive-scroll';


import emailjs from '@emailjs/browser';





class App{

constructor(){

this.sendBtn = document.querySelector('.send-message-wrapper')    
this.hamburger = document.querySelector('.hamburger-icon')    
this.close = document.querySelector('.offcanvas-close-icon')    

this.primaryButton = document.querySelectorAll('.primary__btn')    
this.primaryText = document.querySelectorAll('.primary__text')
this.allMouseOverImages  = document.querySelectorAll('img') 

this.allMouseOverText = [...this.primaryButton,...this.primaryText]


this.createRotateTitle()  


this.createIntersectionObserver()
this.createLocomotiveScroll()

this.createBarba()
this.onEmailInit()

this.addEventListeners()


}


createIntersectionObserver(){


this.intersects = document.querySelectorAll(".intersect")


this.observer = new IntersectionObserver(entries =>{

entries.forEach(entry=>{

this.intersectImg = [...entry.target.querySelectorAll('img')]
this.intersectTitle  = [...entry.target.querySelectorAll('.intersect-text')]
GSAP.set(this.intersectTitle,{opacity:0,y:50})    
GSAP.set(this.intersectImg,{scale:1.2})    

if (entry.isIntersecting) {

GSAP.to(this.intersectImg,{scale:1,clipPath:"inset(0% 0 0% 0)",duration:1,ease:"Power4.ease.Out"})
GSAP.to(this.intersectTitle,{opacity:1,y:0,duration:1.5,ease:"Expo.ease.Out"})
this.observer.unobserve(entry.target)
}
})

},{
    root: null, 
    rootMargin: '0px', 
    threshold: 0.25  
})

this.intersects.forEach(targets=>{

this.observer.observe(targets)

})



}



createLocomotiveScroll(){

this.locomotiveScroll = new LocomotiveScroll({
    el:document.querySelector(".smooth__scroll"),
    smooth:true,
    lerp : 0.075,
    reloadOnContextChange:true
})

}

createBarba(){



const easeIn = (container,isDone)=>{

return GSAP.to(container,{opacity:0,y:60,duration:1.5,ease:'Power4.in',clearProps:'all',onComplete:()=> isDone()})

}

const easeOut = (container)=>{

return GSAP.from(container,{opacity:0,y:60,duration:1.5,ease:'Power4.inOut',clearProps:'all'})

}



barba.init({
sync:true,

transitions: [{

once({next}){
easeOut(next.container) 


},


leave({current}) {
const isDone = this.async();
easeIn(current.container,isDone) 

},
enter({next}) {
    
easeOut(next.container)  
},


}],



})


barba.hooks.before(() => {

this.locomotiveScroll.destroy()


});



barba.hooks.after(() => {

this.primaryButton = document.querySelectorAll('.primary__btn') 
this.sendBtn = document.querySelector('.send-message-wrapper')
this.primaryText = document.querySelectorAll('.primary__text') 
this.allMouseOverText = [...this.primaryButton,...this.primaryText ]
this.close = document.querySelector('.offcanvas-close-icon') 
this.hamburger = document.querySelector('.hamburger-icon') 
this.allMouseOverImages  = document.querySelectorAll('img') 


this.createIntersectionObserver()

this.createRotateTitle()
this.onEmailInit()
this.addEventListeners()

this.locomotiveScroll.init()




});


}


createRotateTitle(){

this.tiltes = [...document.querySelectorAll(".rotate__title")]

this.tiltes.forEach(item=>{

let word = item.children[0].children[0].innerText.split('')

item.children[0].innerHTML = ''
word.forEach((letter,idx)=>{
item.children[0].innerHTML += `<span style="--index:${idx};">${letter}</span>`

})

let cloneDiv = item.children[0].cloneNode(true)
cloneDiv.style.position = 'absolute'
cloneDiv.style.top = '0'
cloneDiv.style.left = '0'
item.appendChild(cloneDiv)


})

}






onEmailInit(){

emailjs.init({

publicKey: 'COvvDfNuYoDeRJRsK',

})



}


onEmailSend(){

this.emailParams = {

from_name : document.querySelector('form #name').value,
email_id : document.querySelector('form #email').value,
phone_id : document.querySelector('form #phone').value,
subject : document.querySelector('form #subject').value,
message : document.querySelector('form #message').value,

}  


emailjs.send('service_dlgsyyz','template_eaysstm',this.emailParams).then(console.warn('message have been send'))


}


onMouseOverText(e){

this.PTL = GSAP.timeline({paused:true})

if (e.target) {


this.PTL.to(e.target,{'--after':'0%',duration:0.3,ease:"Power0.easeIn"})
this.PTL.to(e.target,{'--before':'100%',duration:0.3,ease:"Power0.easeOut"})
this.PTL.to(e.target,{clearProps:'all'}) 


}

this.PTL.play()


}




createCanvasOpen(){

this.CTL = GSAP.timeline({paused:true})
this.CTL.to('.offcanvas-menu',{height:'100vh',duration:1.2,ease:"Expo.easeInOut"})
this.CTL.fromTo('.offcanvas-navlink-item',{x:-10,opacity:0},{x:0,opacity:1,duration:1,stagger:0.1})
this.CTL.play()

}

createCanvasClose(){
    this.CTL.reverse()  
}

onMouseOverImages(e){
GSAP.to(e.target,{clipPath:"inset(1%)",duration:0.3,ease:"Expo.ease.in"})

}

onMouseOutImages(e){
GSAP.to(e.target,{clipPath:"inset(0%)",duration:0.3,ease:"Expo.ease.Out"})

}


addEventListeners(){


this.allMouseOverText.forEach(element=>{

element.addEventListener('mouseover',this.onMouseOverText.bind(this))
    
}) 


this.allMouseOverImages.forEach(t=>{
    t.addEventListener('mouseover',this.onMouseOverImages.bind(this))
})

this.allMouseOverImages.forEach(o=>{
    o.addEventListener('mouseout',this.onMouseOutImages.bind(this))
})


if (this.sendBtn) {
   
this.sendBtn.addEventListener('click',(e)=>{
    e.preventDefault()
    this.onEmailSend()
    
})


}


this.hamburger.addEventListener('click',this.createCanvasOpen.bind(this))
this.close.addEventListener('click',this.createCanvasClose.bind(this))




}




}


new App()








